import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  isOpenSidebar: false,
  tag: {
    size: 10,
    page: 0,
  },
  isOpenBanner: false,
  isOpenBannerGroups: false,
  details: null,
  isOpenModal: false,
  loading: false,
  isOpenModalDelete: false,
  bannerMsg: '',
  rolesFarmers: [],
  rolesPMB: [],
}

export const warehouseSlice = createAppSlice({
  name: 'warehouse',
  initialState,
  reducers: (create) => ({
    toggleSidebar: create.reducer((state, { payload }) => {
      state.isOpenSidebar = !state.isOpenSidebar
    }),
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setFetchOptionGroups: create.reducer((state, { payload }) => {
      state.tagGroups.size = payload.size
      state.tagGroups.page = payload.page
    }),
    setFetchOptionSubGroup: create.reducer((state, { payload }) => {
      state.tags[payload.id].size = payload.size
      state.tags[payload.id].page = payload.page
    }),
    toggleBanner: create.reducer((state, { payload }) => {
      state.isOpenBanner = !state.isOpenBanner
    }),
    toggleBannerGroups: create.reducer((state, { payload }) => {
      state.isOpenBannerGroups = !state.isOpenBannerGroups
    }),
    toggleModal: create.reducer((state, { payload }) => {
      state.isOpenModal = !state.isOpenModal
    }),
    toggleModalDelete: create.reducer((state, { payload }) => {
      state.isOpenModalDelete = !state.isOpenModalDelete
    }),
    setBannerMsg: create.reducer((state, { payload }) => {
      state.bannerMsg = payload
    }),
  }),
  extraReducers: (builder) => {},
})

export const {
  setFetchOption,
  toggleSidebar,
  toggleBanner,
  toggleModal,
  setFetchOptionGroups,
  setFetchOptionSubGroup,
  toggleBannerGroups,
  toggleModalDelete,
  setBannerMsg,
} = warehouseSlice.actions

export default warehouseSlice.reducer
